export default __webpack_public_path__ + "static/media/suggestion-chips-watson-actions2.c1be11f4.png";